import { createFileRoute } from '@tanstack/react-router'
import { CanView } from '@/components/can-view'
import { PermissionsSettingsPage } from '@/features/permissions/ui/permissions-settings-page'

export const Route = createFileRoute('/_authenticated/settings/permissions')({
	component: () => (
		<CanView permission='settings.permissions.manage'>
			<PermissionsSettingsPage />
		</CanView>
	),
})
